import { I18N } from "aurelia-i18n";
import { autoinject } from "aurelia-framework";
import routerHelper from "helpers/routerHelper";
import additionalFieldsService from "services/additionalFieldsService";
import { AdditionalFieldsSourceType } from "enums/additional-fields-source-type";

@autoinject
export class DailyEntryAdditionalFields {

    public actions: any = {};
    public dispatchDate: Date = new Date();
    public dispatchProjectCode: string = "";
    public readonly: boolean = false;
    public additionalFieldsSource: number = AdditionalFieldsSourceType.DailyEntry;
    public saveAdditionalFieldsButton: boolean = true;

    constructor(private readonly i18n: I18N) {
    }

    public activate(params: any): any {
        this.bindViewModel(params.dispatchProjectCode, params.dailyEntryDate, params.q);
        this.bindWidget();
    }

    public bindViewModel(dispatchProjectCode: string, dispatchDate: Date, queryString: string): void {
        const params = routerHelper.getQuerystring(queryString);
        this.readonly = !(params && params.readonly === "false");

        this.dispatchProjectCode = dispatchProjectCode;
        this.dispatchDate = dispatchDate;
    }

    public bindWidget(): void {
        this.actions = {
            getAll: additionalFieldsService.getAllForProject.bind(this, this.dispatchProjectCode, this.dispatchDate),
            setAll: additionalFieldsService.setAllForProject.bind(this, this.dispatchProjectCode, this.dispatchDate)
        };
    }
}
